export enum Type {
  Success = 'Success',
  Danger = 'Danger',
  Warning = 'Warning',
  Info = 'Info',
}
